// extracted by mini-css-extract-plugin
export default {"title":"Style_title__J+0eL","w100":"Style_w100__ADOjq","wrapper":"Style_wrapper__2k9KW","fontBold":"Style_fontBold__wqgFG"};